/** @jsx jsx */
import type { Interpolation, Theme } from '@emotion/react';
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Tag } from '@coursera/cds-core';

type Props = {
  skills?: (string | null | undefined)[] | null;
  color?: 'highlight1' | 'default';
  variant?: 'category' | 'status';
  style?: Record<string, Interpolation<Theme>>;
};

const containerStyle: Interpolation<Theme> = () => css`
  margin-bottom: var(--cds-spacing-300);
`;

const Skills: React.FC<Props> = ({ skills, color = 'default', variant = 'category', style }) => {
  if (!skills?.length) {
    return null;
  }
  return (
    <Grid container css={containerStyle} spacing={8}>
      {skills?.map(
        (skill, index) =>
          skill && (
            // eslint-disable-next-line react/no-array-index-key
            <Grid item key={index}>
              <Tag variant={variant} priority="primary" color={color} style={style}>
                {skill}
              </Tag>
            </Grid>
          )
      )}
    </Grid>
  );
};

export default Skills;
